import React, {useContext} from "react";
import {DynamicComponentProps} from "../../core/_models";
import {Col, Row} from "react-bootstrap";
import {Button, ButtonGroup} from "@mui/material";

export function ButtonGroupComponent({config, context}: DynamicComponentProps) {
    const {children} = config
    const items = (Array.isArray(children) ? children : children['items']) || [];

    const formContext = useContext(context!);

    return (
        <Row>
            <Col>
                <ButtonGroup variant="contained" aria-label="outlined primary button group">
                    {(items as { hint: string, text: string, id: number, action: any }[]).map(itemConfig => {
                        const {hint, text, id, action} = itemConfig;

                        return <Button title={hint} variant='contained' color="primary" key={id} onClick={(e) => {
                            if (action != null) {
                                formContext.submit({action})
                            }
                        }}>{text}</Button>
                    })}
                </ButtonGroup>
            </Col>
        </Row>
    )
}